/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Close } from '@dsny/dsny-component-library/icons';
import { t } from 'i18next';
import { ArtistPillWrapper, TruncatingPill } from './ArtistTag.styles';
import { AddTrackObj } from '../MultiAsset.slice';

export interface Props {
  artist: AddTrackObj[];
  displayMultiSelection: boolean;
  tagRemove: (text: string) => void;
  multiTagRemove: () => void;
}

const ArtistTag: React.FC<Props> = ({
  artist,
  displayMultiSelection,
  tagRemove,
  multiTagRemove,
}) => {
  // Handling remove artist tag
  const handleTagRemove = (name: string) => {
    tagRemove(name);
  };

  // Get artist tag list (max of 5 tags per song)
  const getArtistTagList = (tracks: AddTrackObj[]) => {
    const selectedTracks = tracks.filter(
      (track) => !!track.isSelected || track.isActive
    );

    return (
      <>
        {displayMultiSelection ? (
          <TruncatingPill
            label={t('MULTI_ASSET_MULTIPLE_ARTISTS_SELECTED')}
            onClick={() => multiTagRemove()}
            variant="tonal"
            icon={<Close />}
            iconPosition="tailing"
          />
        ) : (
          selectedTracks[0]?.artists.map((a) => {
            return (
              <TruncatingPill
                key={a.code}
                label={a.name}
                onClick={() => handleTagRemove(a.name)}
                variant="tonal"
                icon={<Close />}
                iconPosition="tailing"
              />
            );
          })
        )}
      </>
    );
  };

  return (
    <>
      {/* Artist tag list */}
      <ArtistPillWrapper>{getArtistTagList(artist)}</ArtistPillWrapper>
    </>
  );
};

export default ArtistTag;
